import api from '../../services/api';

// Action types
export const CHECK_INVITE_ELIGIBILITY_REQUEST = 'CHECK_INVITE_ELIGIBILITY_REQUEST';
export const CHECK_INVITE_ELIGIBILITY_SUCCESS = 'CHECK_INVITE_ELIGIBILITY_SUCCESS';
export const CHECK_INVITE_ELIGIBILITY_FAILURE = 'CHECK_INVITE_ELIGIBILITY_FAILURE';

export const VERIFY_INVITE_CODE_REQUEST = 'VERIFY_INVITE_CODE_REQUEST';
export const VERIFY_INVITE_CODE_SUCCESS = 'VERIFY_INVITE_CODE_SUCCESS';
export const VERIFY_INVITE_CODE_FAILURE = 'VERIFY_INVITE_CODE_FAILURE';

export const RESET_INVITE_STATE = 'RESET_INVITE_STATE';

/**
 * 检查用户邀请码填写资格
 */
export const checkInviteEligibility = () => {
  return async (dispatch) => {
    dispatch({ type: CHECK_INVITE_ELIGIBILITY_REQUEST });
    
    try {
      const response = await api.get('/user/invite-code-eligibility');
      
      dispatch({
        type: CHECK_INVITE_ELIGIBILITY_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '检查邀请码资格失败';
      
      dispatch({
        type: CHECK_INVITE_ELIGIBILITY_FAILURE,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};

/**
 * 验证并使用邀请码
 */
export const verifyInviteCode = (inviteCode) => {
  return async (dispatch) => {
    dispatch({ type: VERIFY_INVITE_CODE_REQUEST });
    
    try {
      const response = await api.post('/user/verify-invite-code', {
        inviteCode: inviteCode.trim()
      });
      
      dispatch({
        type: VERIFY_INVITE_CODE_SUCCESS,
        payload: response.data
      });
      
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || '验证邀请码失败';
      
      dispatch({
        type: VERIFY_INVITE_CODE_FAILURE,
        payload: errorMessage
      });
      
      throw error;
    }
  };
};

/**
 * 重置邀请码状态
 */
export const resetInviteState = () => {
  return {
    type: RESET_INVITE_STATE
  };
}; 